'use client';

import { useEffect, useRef } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { useSurveyModal } from './SurveyModalsManager';

/**
 * When the URL has ?survey=<surveyId> (and optional &surveyTitle=...),
 * open the survey modal and remove the params. Aligned with academy-1.0 trigger options.
 */
export function OpenSurveyFromQuery() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { openSurveyModal } = useSurveyModal();
  const didOpenRef = useRef(false);

  useEffect(() => {
    const surveyId = searchParams.get('survey');
    const surveyTitle = searchParams.get('surveyTitle');

    if (!surveyId) {
      didOpenRef.current = false;
      return;
    }
    if (didOpenRef.current) return;

    didOpenRef.current = true;
    openSurveyModal(surveyId, surveyTitle || undefined);

    if (typeof window !== 'undefined') {
      const url = new URL(window.location.href);
      url.searchParams.delete('survey');
      url.searchParams.delete('surveyTitle');
      const clean = url.pathname + (url.search || '') + (url.hash || '');
      window.history.replaceState({}, '', clean || pathname || '/');
    }
  }, [pathname, searchParams, openSurveyModal]);

  return null;
}
